import React from "react";

import classes from "./Backdrop.module.scss";

interface IProps {
  isOpen: boolean;
  onClick: () => void;
}

const Backdrop: React.FC<IProps> = ({ isOpen, onClick }) => {
  let containerClasses = [classes.Backdrop];

  if (isOpen) {
    containerClasses.push(classes.Active);
  }

  return <div className={containerClasses.join(" ")} onClick={onClick} />;
};

export default Backdrop;
